import {BaseAuthenticationMethod} from '@shared/models/signrequest/authentication/base-authentication-method';

export class Certificate extends BaseAuthenticationMethod {
    type = 'certificate';
}
